<div class="content-container">
  <div class="dashboard-header">
    <div class="header-left">
      <!-- State 3: Show "Create chart" text when creating chart -->
      <h2 class="header-title" *ngIf="showChartForm">Create chart</h2>
      <!-- State 1 & 2: Show dashboard controls when not creating chart -->
      <ng-container *ngIf="!showChartForm">
        <!-- Dashboard selector dropdown (shown only in view mode when dashboardId exists) -->
        <div class="dashboard-selector-wrapper" *ngIf="allDashboards.length > 0 && dashboardId && isViewMode">
          <div class="dashboard-selector-container">
            <div class="dashboard-selector-button" (click)="toggleDashboardDropdown()">
              <span class="selector-text">{{ getSelectedDashboardName() }}</span>
              <img src="assets/icons/keyboard_arrow_down.svg" alt="dropdown" class="dropdown-icon" [class.rotated]="showDashboardDropdown">
            </div>
            <div class="shared-badge" *ngIf="isSharedWithAll" title="Shared dashboard">
              <img src="assets/icons/user-dashbaord/share-dashboard.svg" alt="shared" class="shared-icon" />
              <span class="shared-text">Shared</span>
            </div>
          </div>
          <div class="dashboard-dropdown-menu" *ngIf="showDashboardDropdown" (click)="$event.stopPropagation()">
            <div class="dropdown-header">
              <div class="header-title">Select Dashboard to Switch</div>
            </div>
            <div class="dropdown-search">
              <input
                type="text"
                class="search-input"
                placeholder="Search"
                [(ngModel)]="dashboardSearchQuery"
                (click)="$event.stopPropagation()"
              />
            </div>
            <div class="dropdown-list">
              <div
                class="dropdown-item"
                *ngFor="let dashboard of getFilteredDashboards()"
                [class.selected]="dashboard.id === dashboardId"
                (click)="onDashboardSwitch(dashboard.id)"
              >
                {{ dashboard.name }}
              </div>
              <div class="no-results" *ngIf="getFilteredDashboards().length === 0 && dashboardSearchQuery">
                No dashboards found
              </div>
            </div>
            <div class="dropdown-footer">
              <button class="view-all-button" (click)="handleViewAllDashboards()">
                View All Dashboards
              </button>
            </div>
          </div>
        </div>
        <!-- Dashboard title input (shown only in edit mode) -->
        <div class="dashboard-title-wrapper" *ngIf="isEditMode">
          <input
            type="text"
            class="dashboard-title-input"
            [class.editing]="isEditingTitle"
            [class.untitled]="dashboardName === 'Untitled Dashboard' || dashboardName.trim() === ''"
            [(ngModel)]="dashboardName"
            (ngModelChange)="onDashboardNameChange()"
            (dblclick)="enableTitleEdit()"
            (blur)="disableTitleEdit()"
            (focus)="enableTitleEdit()"
            placeholder="Untitled Dashboard"
            maxlength="100"
          />
          <div class="shared-badge" *ngIf="isSharedWithAll" title="Shared dashboard">
            <img src="assets/icons/user-dashbaord/share-dashboard.svg" alt="shared" class="shared-icon" />
            <span class="shared-text">Shared</span>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="header-right" *ngIf="!showChartForm">
      <!-- View Mode: Show only dropdown, refresh, edit, and more buttons -->
      <ng-container *ngIf="isViewMode && dashboardId">
        <button
          class="btn-refresh"
          (click)="handleSync()"
          [disabled]="isLoadingDashboard || isSyncing"
          [class.syncing]="isSyncing"
          matTooltip="Refresh all charts with current data. Regular-update tags like This Month and This Year are recalculated from today."
          matTooltipPosition="below"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.00008 2.66675V0.666748L5.33341 3.33341L8.00008 6.00008V4.00008C10.2067 4.00008 12.0001 5.79341 12.0001 8.00008C12.0001 8.67341 11.8334 9.31342 11.5334 9.86675L12.5067 10.8401C13.0267 10.0201 13.3334 9.04675 13.3334 8.00008C13.3334 5.05341 10.9467 2.66675 8.00008 2.66675ZM8.00008 12.0001C5.79341 12.0001 4.00008 10.2067 4.00008 8.00008C4.00008 7.32675 4.16675 6.68675 4.46675 6.13341L3.49341 5.16008C2.97341 5.98008 2.66675 6.95341 2.66675 8.00008C2.66675 10.9467 5.05341 13.3334 8.00008 13.3334V15.3334L10.6667 12.6667L8.00008 10.0001V12.0001Z" fill="#1E2225"/>
          </svg>
          <span>{{ isSyncing ? 'Syncing...' : 'Sync' }}</span>
        </button>
        <button class="btn-edit" (click)="handleEditClick()">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.33333 13.35C0.966667 13.35 0.652778 13.2194 0.391667 12.9583C0.130556 12.6972 0 12.3833 0 12.0167V2.68333C0 2.31667 0.130556 2.00278 0.391667 1.74167C0.652778 1.48056 0.966667 1.35 1.33333 1.35H7.28333L5.95 2.68333H1.33333V12.0167H10.6667V7.38333L12 6.05V12.0167C12 12.3833 11.8694 12.6972 11.6083 12.9583C11.3472 13.2194 11.0333 13.35 10.6667 13.35H1.33333ZM4 9.35V6.51667L10.1167 0.4C10.25 0.266667 10.4 0.166667 10.5667 0.1C10.7333 0.0333333 10.9 0 11.0667 0C11.2444 0 11.4139 0.0333333 11.575 0.1C11.7361 0.166667 11.8833 0.266667 12.0167 0.4L12.95 1.35C13.0722 1.48333 13.1667 1.63056 13.2333 1.79167C13.3 1.95278 13.3333 2.11667 13.3333 2.28333C13.3333 2.45 13.3028 2.61389 13.2417 2.775C13.1806 2.93611 13.0833 3.08333 12.95 3.21667L6.83333 9.35H4ZM5.33333 8.01667H6.26667L10.1333 4.15L9.66667 3.68333L9.18333 3.21667L5.33333 7.06667V8.01667Z" fill="#1E2225"/>
          </svg>
          <span>Edit</span>
        </button>
        <div class="more-dropdown-container">
          <button class="btn-more" (click)="toggleMoreDropdown()">
            <img src="assets/icons/user-dashbaord/more-btn.svg" alt="more options" />
          </button>
          <div class="more-dropdown" *ngIf="showMoreDropdown" (click)="$event.stopPropagation()">
            <!-- <button class="dropdown-menu-item" (click)="handleSetDefaultView()">
              <img src="assets/icons/user-dashbaord/set-default-view.svg" alt="set default" class="menu-icon" />
              <span>Set Default View</span>
            </button> -->
            <button class="dropdown-menu-item" (click)="handleShareDashboard()">
              <img src="assets/icons/user-dashbaord/share-dashboard.svg" alt="share" class="menu-icon" />
              <span>{{ getShareButtonText() }}</span>
            </button>
            <button class="dropdown-menu-item" (click)="handleViewAllDashboardsFromMore()">
              <img src="assets/icons/user-dashbaord/view-all-dashboards.svg" alt="view all" class="menu-icon" />
              <span>View All Dashboards</span>
            </button>
            <button class="dropdown-menu-item delete-item" (click)="handleDeleteDashboard()">
              <img src="assets/icons/delete_outline.svg" alt="delete" class="menu-icon" />
              <span>Delete Dashboard</span>
            </button>
          </div>
        </div>
      </ng-container>
      <!-- Edit Mode: Show all edit buttons (for both new and existing dashboards) -->
      <ng-container *ngIf="isEditMode">
        <div class="layout-dropdown-container">
          <button class="btn-layout" (click)="handleChangeLayout()">
            <span>Change Layout</span>
          </button>
          <div class="layout-dropdown" *ngIf="showLayoutDropdown">
            <div class="dropdown-section">
              <div class="dropdown-header">Select Layout</div>
              <button
                class="dropdown-item"
                *ngFor="let layout of layouts"
                [class.active]="selectedLayout === layout.id"
                (click)="handleChangeLayout(layout.id)">
                <div class="layout-icon">
                  <img *ngIf="layout.id === '1-column'" src="assets/icons/user-dashbaord/one-column.svg" alt="One column layout" />
                  <img *ngIf="layout.id === '2-column'" src="assets/icons/user-dashbaord/two-column.svg" alt="Two column layout" />
                </div>
                <span>{{ layout.name }}</span>
              </button>
            </div>
          </div>
        </div>
        <button class="btn-add-chart" (click)="handleAddChart()">
          <span>Add Chart</span>
        </button>
        <div class="more-dropdown-container">
          <button class="btn-more" (click)="toggleMoreDropdown()">
            <img src="assets/icons/user-dashbaord/more-btn.svg" alt="more options" />
          </button>
          <div class="more-dropdown" *ngIf="showMoreDropdown" (click)="$event.stopPropagation()">
            <!-- <button class="dropdown-menu-item" (click)="handleSetDefaultView()">
              <img src="assets/icons/user-dashbaord/set-default-view.svg" alt="set default" class="menu-icon" />
              <span>Set Default View</span>
            </button> -->
            <button class="dropdown-menu-item" (click)="handleShareDashboard()">
              <img src="assets/icons/user-dashbaord/share-dashboard.svg" alt="share" class="menu-icon" />
              <span>{{ getShareButtonText() }}</span>
            </button>
            <button class="dropdown-menu-item" (click)="handleViewAllDashboardsFromMore()">
              <img src="assets/icons/user-dashbaord/view-all-dashboards.svg" alt="view all" class="menu-icon" />
              <span>View All Dashboards</span>
            </button>
            <button class="dropdown-menu-item delete-item" (click)="handleDeleteDashboard()">
              <img src="assets/icons/delete_outline.svg" alt="delete" class="menu-icon" />
              <span>Delete Dashboard</span>
            </button>
          </div>
        </div>
        <button class="btn-save" [disabled]="!canSave()" (click)="handleSave()">
          <span>Save</span>
        </button>
        <button class="btn-cancel" (click)="handleCancel()">
          <span>Cancel</span>
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Chart Configuration Side Panel (overlay) -->
  <div class="chart-config-overlay" *ngIf="showChartForm" (click)="handleCloseAddChartPanel()">
    <div class="chart-config-panel" (click)="$event.stopPropagation()">
      <div class="panel-header">
        <h3 class="panel-title">{{ editingChart ? 'Edit Chart' : 'Configure Chart' }}</h3>
        <button class="btn-close-panel" (click)="handleCloseAddChartPanel()" title="Close">
          ×
        </button>
      </div>
      <div class="panel-content">
        <add-chart
          [showTemplatesOnly]="false"
          [selectedSlot]="selectedChartSlot"
          [existingChart]="editingChart"
          [chartId]="editingChartId"
          [preselectedChartTypeId]="preselectedChartTypeId"
          (chartAdded)="handleChartAdded($event)"
          (chartUpdateFailed)="handleChartUpdateFailed($event)"
          (cancel)="handleCloseAddChartPanel()"
          (chartSelected)="handleChartSelected($event)"
        ></add-chart>
      </div>
    </div>
  </div>

  <div class="dashboard-body">
    <!-- Loading state for dashboard -->
    <div *ngIf="isLoadingDashboard" class="dashboard-loading">
      <div class="loading-spinner"></div>
      <p>Loading dashboard...</p>
    </div>

    <div class="sync-overlay" *ngIf="isSyncing && !isLoadingDashboard">
      <div class="loading-spinner"></div>
      <p>Syncing charts with current data...</p>
    </div>

    <!-- Dashboard content -->
    <div class="chart-canvas" [ngClass]="'layout-' + selectedLayout" *ngIf="!isLoadingDashboard">
      <div
        class="chart-slot"
        *ngFor="let slot of getChartSlots(); let i = index"
        [class.empty]="!charts[i]"
        (click)="!charts[i] && isEditMode && handleChartSlotClick(i)"
      >
        <div *ngIf="charts[i]; else emptySlot" class="chart-wrapper">
          <div class="chart-content">
            <app-chart-overview
              [chartData]="charts[i]"
              [chartIndex]="i"
              [isEditMode]="isEditMode"
              [hasUnsavedChanges]="hasUnsavedChanges"
              (editRequested)="editChart(i)"
              (deleteRequested)="handleRemoveChartFromMenu(i)"
              (downloadRequested)="handleDownloadChart(i)"
              (saveAndLargeViewRequested)="handleSaveAndLargeView(i)"
            ></app-chart-overview>
          </div>
        </div>
        <ng-template #emptySlot>
          <div class="empty-slot-content" *ngIf="isEditMode" (click)="handleChartSlotClick(i)">
            <img src="assets/icons/user-dashbaord/add-chart.svg" alt="add chart" class="empty-icon">
            <p class="empty-slot-text">Start by adding a new chart from the <span>"Add Charts"</span> panel</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Add Charts Panel Overlay -->
    <div class="add-charts-overlay" *ngIf="showAddChartPanel && !showChartForm" (click)="handleCloseAddChartPanel()">
      <div class="add-charts-panel" (click)="$event.stopPropagation()">
        <add-chart
          [showTemplatesOnly]="true"
          (close)="handleCloseAddChartPanel()"
          (chartSelected)="handleChartSelected($event)"
        ></add-chart>
      </div>
    </div>
  </div>
</div>
